import React, {Component} from "react";
import { Line } from 'react-chartjs-2';
import ReactToPrint from "react-to-print";
import FeatherIcon from 'feather-icons-react';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title, CategoryScale } from 'chart.js';
import UserIdentity from "../../users/UserIdentity";
import Headerpdf from "../../users/Headerpdf";
import { getThemeColor } from "../../../theme/branding";
ChartJS.register(CategoryScale, LineElement, PointElement, LinearScale, Title);

const createDataset = (data, color = getThemeColor()) => ({
  label: 'Donnees',
  fill: true,
  tension: 0.35,
  backgroundColor: `${color}1f`,
  borderColor: color,
  pointBackgroundColor: color,
  pointBorderColor: '#fff',
  pointHoverBackgroundColor: '#fff',
  pointHoverBorderColor: color,
  borderWidth: 2,
  data
});

class   SchoolfeeLine extends Component{

    state = {
        labels: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
        data: [],
        datasets: [createDataset([47, 35, 66, 52, 33, 44, 20, 66, 12, 22, 44, 59])]
      }

      componentDidMount(){
        window.addEventListener("evivesoma:theme", this.handleThemeChange);

        if(this.props.data)
        {
          this.setState({
              data : this.props.data,
              datasets: [createDataset(this.props.data)]
          })
        }

        if(this.props.labels)
        {
          this.setState({
            labels : this.props.labels
          })
        }
      }

      componentWillUnmount(){
        window.removeEventListener("evivesoma:theme", this.handleThemeChange);
      }

      handleThemeChange = (event) => {
        const color = event.detail || getThemeColor();
        this.setState((state) => ({
          datasets: state.datasets.map((dataset) => createDataset(dataset.data, color))
        }));
      }

    render(){
        
        return(
        <div>
          <div className="text-end">
              <ReactToPrint
                  trigger={() => <button className="btn btn-sm btn-outline-primary rounded rounded-3" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                  content={() =>  this.componentRef}
              />
          </div>
          <div ref={el => (this.componentRef = el)}>
            <div className="m-2 ml-4">
              <Headerpdf />
               <UserIdentity matricule ={this.props.matricule} name={this.props.name} classe={this.props.classe} title={this.props.title} /> 
           
          {
            this.state.data.length > 0 && (
            <Line
                data={this.state}
                options={{
                    title:{
                    display:true,
                    text:'Données',
                    fontSize:20
                    },
                    legend:{
                    display:true,
                    position:'right'
                    }
                }}
                />
              )
            }
            </div>
          </div>
        </div>
        )
    }
}
export default SchoolfeeLine;